export default {
  VALIDATED: 'Validado',
  VALIDATING: 'Validando',
  INVALID: 'Inválido'
};
